<script>
    import { setContext } from 'svelte'

    export let height = '500px';

    let mode = "user"
    let user = null
    let dpo = null
 
    setContext('section', {
        asDPO  : () => { as('dpo') },
        asUser : () => { as('user') }
    })

    function as(to) {
        mode = to
    }

    $: bg = mode === 'user' ? 'var(--blue-color)' : 'var(--purple-color)'
</script>
<style>
    section {
        position : relative;
        overflow : hidden;
    }

    section > div {
        position   : absolute;
        width      : 100%;
        height     : 100%;
        top        : 0;
        left       : 0;
        transition : left .8s ease-in;
    }

    .show {
        left: 0 !important;
    }

    .dpo {
        left: 100%;
    }
</style>
<section style="min-height: {height};">
    <div bind:this={user} class="user">
        <slot name="user"/>
    </div>
    <div bind:this={dpo} class="dpo" class:show={mode === 'dpo'}>
        <slot name="dpo"/>        
    </div>
</section>